"use client"

import { useSession } from "next-auth/react"
import { useSearchParams } from "next/navigation"
import { useEffect, useRef } from "react"
import { useMauticTracking } from "@/hooks/useMauticTracking"
import { MAUTIC_CAMPAIGNS, PageViewParams } from "@/lib/mautic-campaign-tags"

export function MauticEmailVerifiedTracker() {
   const { data: session } = useSession()
   const { trackPageView } = useMauticTracking()
   const searchParams = useSearchParams()
   const hasFired = useRef(false)

   useEffect(() => {
      if (hasFired.current) return
      if (searchParams.get("verified") !== "1") return

      const { mt_event, page_title, tags } = MAUTIC_CAMPAIGNS.emailVerified
      const email = session?.user?.email ?? ""
      const params: PageViewParams = {
         mt_event,
         page_title,
         tags,
         page_url: MAUTIC_CAMPAIGNS.emailVerified.pageurl,
      }
      if (email) params.email = email

      trackPageView(params)
      hasFired.current = true
   }, [searchParams, session?.user?.email, trackPageView])

   return null
}
